import { render, staticRenderFns } from "./AppNavigator.vue?vue&type=template&id=33b7b674&scoped=true&"
import script from "./AppNavigator.vue?vue&type=script&lang=js&"
export * from "./AppNavigator.vue?vue&type=script&lang=js&"
import style0 from "./AppNavigator.vue?vue&type=style&index=0&id=33b7b674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7b674",
  null
  
)

export default component.exports